import ActionWrapper from '../components/ListItem/components/ActionWrapper';
import AnchorWrapper from '../components/ListItem/components/AnchorWrapper';
import ButtonWrapper from '../components/ListItem/components/ButtonWrapper';
import type { ListItemType, ListItemVariants } from './types';

export function createListItemVariants<P extends ListItemType>(Component: React.ComponentType<P>): ListItemVariants<P> {
    return {
        Anchor: ({ anchorProps, size, ...restProps }) => (
            <Component
                {...(restProps as unknown as P)}
                WrapperRenderer={(props) => <AnchorWrapper size={size} {...anchorProps} {...props} />}
            />
        ),
        Button: ({ buttonProps, size, ...restProps }) => (
            <Component
                {...(restProps as P)}
                WrapperRenderer={(props) => <ButtonWrapper size={size} {...buttonProps} {...props} />}
            />
        ),
        Action: ({ action, size, ...restProps }) => (
            <Component
                {...(restProps as unknown as P)}
                WrapperRenderer={(props) => <ActionWrapper size={size} action={action} {...props} />}
            />
        )
    };
}
